<template>
    <div v-show="options.filteredActions.length > 1" :class="design">
        <h2 v-if="title" class="title">{{ title }}</h2>

        <div class="column">
            <ui-select-v2
                v-model="form.funnel_stage_id"
                :data="options.filteredStage"
                :disabled="isDisabled.stage"
                :required="isRequired.stage"
                :loading="loader.stage"
                align="left"
                label="Etapa:"
                item-label="name"
                return-value="id"
                design="br-default"
                @input="statusHandler"
            />

            <ui-select-v2
                v-show="options.filteredStatus.length"
                v-model="form.action_id"
                :data="options.filteredStatus"
                :disabled="disableStatus"
                :required="isRequired.status"
                :loading="loader.status"
                align="left"
                label="Status:"
                item-label="name"
                return-value="action_id"
                design="br-default"
                @input="actionHandler"
            />
        </div>
    </div>
</template>

<script>
	import { uiSelectV2 } from '@/components/ui/form'
	import { funnel, action } from '@/services/axios'

	import { utilMixin, formMixin, alertMixin, loaderMixin } from '@/mixins'

	const defaultForm = () => ({
		funnel_stage_id: null,
		action_id: null,
		no_action: false,
	})

	const defaultLoader = () => ({
		stage: false,
		status: false,
	})

	const defaultRequired = () => ({
		stage: true,
		status: true,
	})

	const defaultDisabled = () => ({
		stage: false,
	})

	const defaultOptions = () => ({
		stage: [],
		actions: [],
		filteredStatus: [],
		filteredStage: [],
		filteredActions: [],
	})

	export default {
		name: 'ui-nugget-actions-stage-status-form',

		components: {
			uiSelectV2
		},

		mixins: [utilMixin, formMixin, alertMixin, loaderMixin],

		props: {
			value: {
				type: Object,
				required: true
			},

			title: {
				type: String,
				default: ''
			},

			fetchList: {
				type: Object,
				default: () => ({})
			},

			visible: {
				type: Boolean
			},

			design: {
				type: String,
				default: ''
			},

			requiredFileds: {
				type: Object,
				default: () => ({})
			},

			actionType: {
				type: String,
				required: true,
				default: ''
			},
			/**
			 * Recebe o ID do nugget para event listener
			 */
			nuggetId: {
				type: [String, Number],
				default: ''
			},
		},

		data() {
			return {
				form: { ...defaultForm() },
				disabled: { ...defaultDisabled() },
				options: { ...defaultOptions() },
				loader: { ...defaultLoader() },
				nuggetName: 'nugget-actions-stage-status-form'
			}
		},

		computed: {
			isRequired() {
				return {
					...defaultRequired(),
					...this.requiredFileds
				}
			},

			isDisabled() {
				return {
					stage: this.options.filteredStage.length == 1
				}
			},

			disableStatus() {
				return (
					!this.$mx_hasValue(this.form.funnel_stage_id) ||
					this.options.filteredStatus.length == 0
				)
			},

			isVisible() {
				return this.options.filteredActions.length > 1
			},

			nuggetCompletedName() {
				return this.nuggetName + (this.nuggetId ? '-' + this.nuggetId : '')
			}
		},

		watch: {
			options: {
				deep: true,
				handler(value) {
					this.$emit('update:fetchList', {
						...value,
						actions: this.options.filteredActions,
					})
				}
			},

			form: {
				deep: true,
				handler(value) {
					this.emitForm(value)
				}
			},

			isVisible(value) {
				this.$emit('update:visible', value)
			}
		},

		mounted() {
			this.$root.$on(this.nuggetCompletedName, async () => {
				this.$mx_setLoader('stage', true)

				this.form = { ...defaultForm() }

				this.options.actions = await this.getActions()
				this.options.filteredActions = this.filterActions(this.options.actions)

				if (this.options.filteredActions.length > 1) {
					if (!this.options.stage.length) this.options.stage = await this.getStages()

					this.options.filteredStage = this.filterStages(this.options.stage)

					if (this.options.filteredStage.length === 1) {
						this.form.funnel_stage_id = this.options.filteredStage[0].id
						this.statusHandler(this.form.funnel_stage_id)
					}

					this.$mx_setLoader('stage', false)
					// ...
				} else if (this.options.filteredActions.length === 1) {
					this.form.action_id = this.options.filteredActions[0].id
				} else {
					this.form.no_action = true
				}

				this.emitForm(this.form)
			})

			this.$root.$on('clean--' + this.nuggetCompletedName, () => {
				this.form = { ...defaultForm() }
				this.disabled = { ...defaultDisabled() }
				this.options = { ...defaultOptions() }
				this.loader = { ...defaultLoader() }
			})
		},

		beforeDestroy() {
			this.$root.$off(this.nuggetCompletedName)
			this.$root.$off('clean--' + this.nuggetCompletedName)
		},

		methods: {
			async getStages() {
				try {
					return (await funnel.getStages()).data
				} catch (error) {
					this.$mx_alertThisOnError(error)
					return []
				}
			},

			async getActions() {
				try {
					return (
						await action.getAllV2('', {
							groupby: 'funnel_stage_id,funnel_stage_status_id,id',
							orderby: 'funnel_stage_status_id'
						})
					).data.data
				} catch (err) {
					this.$mx_alertThisOnError(err)
					return []
				}
			},

			async statusHandler(id) {
				this.options.filteredStatus = []

				if (!this.$mx_hasValue(id)) {
					this.form.action_id = null
					return
				}

				this.options.filteredStatus = this.filterStatus(this.getStatusByStageId(id))
				this.form.action_id = null

				if (this.options.filteredStatus.length === 0) {
					this.form.action_id = null
					this.form.action_id = this.options.filteredActions.find(
						(a) => a.funnel_stage_id == id && a.funnel_stage_status_id === null
					).id
				}
			},

			actionHandler(id) {
				if (!this.$mx_hasValue(id)) {
					this.form.action_id = null
				}
			},

			getStatusByStageId(id) {
				if (!this.$mx_hasValue(id) && this.options.filteredStage.length) return []
				const stage = this.options.filteredStage.find((s) => s.id === parseInt(id))
				if (!stage) return []
				return [...stage.status]
			},

			filterActions(actionsList) {
				return actionsList.filter((a) => a.action == this.actionType)
			},

			filterStages(stageList) {
				return stageList.filter((stage) => {
					let actual = null
					for (let a of [...this.options.filteredActions]) {
						if (a.funnel_stage_id === stage.id) actual = stage
					}
					if (actual) return actual
				})
			},

			filterStatus(statusList) {
				return statusList
					.filter((status) => {
						const index = this.options.filteredActions.findIndex(
							(a) => a.funnel_stage_status_id === status.id
						)
						return index !== -1
					})
					.map((status) => {
						const act = this.options.filteredActions.find(
							(a) => a.funnel_stage_status_id === status.id
						)
						return {
							...status,
							action_id: act.id
						}
					})
			},

			emitForm(value) {
				this.$emit('input', {
					action: this.actionType,
					action_id: value.action_id,
					no_action: value.no_action
				})
			}
		}
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
